export enum SaleMethod {
    OnTheirOwn = 'OnTheirOwn',
    WithRealtors = 'WithRealtors',
    DontKnowYet = 'DontKnowYet',
}
